import OscarSearchPageContent from "../_shared/OscarSearchPageContent";

import css from "./OscarSearchPage.module.scss";

// The shared StotlesAPI client and ApiContextProvider are supplied by AppProviders
// at the router root, so this page only needs to render its content.
export function OscarSearchPage(): JSX.Element {
  return (
    <div className={css.pageLayout}>
      <OscarSearchPageContent />
    </div>
  );
}
